import styled, { css, keyframes } from 'styled-components';

import { cssDeclaration } from '../Utils/Styles/cssDeclaration';

import { IBarProgressProps } from './BarProgress.type';

export const BarContainer = styled.div`
  ${ ({ theme: { themeTwo } }) => css`
    width: 100%;
    position: relative;
    overflow: hidden;

    ${ cssDeclaration(themeTwo, 'height', themeTwo.barProgress.track.height) };
    ${ cssDeclaration(themeTwo, 'border-radius', themeTwo.barProgress.borderRadius) };
    ${ cssDeclaration(themeTwo, 'background-color', themeTwo.barProgress.track.color.base) };
    `
  })
`;

export const Bar = styled.div<IBarProgressProps>`
  ${ ({ percentage, color, animate, animationDelay, theme: { themeTwo } }) => {
    const progress = 100 - percentage;
    const slideInLeft = keyframes`
      from {
        transform: translateX(0);
      }

      to {
        transform: translateX(${ progress }%);
      }
    `;
    const frames = css`${ slideInLeft }`;
    const animation = css`${ frames } 600ms linear ${animationDelay} forwards`;

    return css`
      position: absolute;
      top: 0;
      height: 100%;
      width: 100%;
      right: 100%;

      ${ cssDeclaration(themeTwo, 'background-color', color || themeTwo.barProgress.track.color.progress) };
      ${ cssDeclaration(themeTwo, 'border-radius', themeTwo.barProgress.borderRadius) };
      ${animate ? css`animation: ${ animation }` : css`right: ${progress}%`};
    `;
  } }
`;
